// extracted by mini-css-extract-plugin
module.exports = {"responsiveImageContainer":"ResponsiveImage_responsiveImageContainer__A9NzB","responsiveImage":"ResponsiveImage_responsiveImage__ksKrX"};